import { CSSProperties } from 'react';
import styled from 'styled-components';
import { SkeletonInputProps } from 'antd/es/skeleton/Input';
import SkeletonBase from 'antd/es/skeleton/Skeleton';

interface Props {
  width: CSSProperties['width'];
  height: CSSProperties['height'];
}

const Skeleton = styled(({ className }: SkeletonInputProps) => (
  <SkeletonBase.Input rootClassName={className} active />
))<Props>`
  && .ant-skeleton-input {
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    min-width: unset;
    opacity: 0.5;
  }
`;

export default Skeleton;
